// 엑심베이 결제 시스템 환경 설정

export interface EximbayConfig {
  apiUrl: string;
  mid: string;
}

export const EXIMBAY_CONFIGS = {
  test: {
    apiUrl: 'https://api-test.eximbay.com',
    mid: '1849705C64'
  },
  production: {
    apiUrl: 'https://api.eximbay.com',
    mid: '2BF8734A18'
  }
} as const;

/**
 * 현재 환경에 맞는 엑심베이 설정 반환
 */
export const getEximbayConfig = (): EximbayConfig => {
  const hostname = window.location.hostname;
  
  // 운영 환경 감지
  if (hostname.includes('koreaorder.com') || 
      hostname.includes('amazonaws.com') || 
      hostname.includes('cloudfront.net') ||
      hostname.includes('github.io')) {
    return EXIMBAY_CONFIGS.production;
  }
  
  // 기본값: 테스트 환경
  return EXIMBAY_CONFIGS.test;
};

/**
 * 환경별 return_url 생성
 */
export const getReturnUrl = (): string => {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost') {
    return 'http://localhost:3000/#/payment-callback';
  } else if (hostname.includes('github.io')) {
    return 'https://delivereee.github.io/home/#/payment-callback';
  } else if (hostname.includes('koreaorder.com')) {
    return 'https://koreaorder.com/#/payment-callback';
  }
  
  // 기본값 (HashRouter 경로 포함)
  return `${window.location.origin}/#/payment-callback`;
};

/**
 * 환경별 status_url 생성 (서버 웹훅용)
 */
export const getStatusUrl = (): string => {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost') {
    return 'http://localhost:8084/api/orders/payment/eximbay/status';
  } else if (hostname.includes('brainbackdoor.com')) {
    return 'https://api.brainbackdoor.com/api/orders/payment/eximbay/status';
  } else {
    return 'https://api.brainbackdoor.com/api/orders/payment/eximbay/status';
  }
};
